export const GoogleAnalyticsEnum = {
    CALL: 'call',
    ADD_TO_CART: 'add_to_cart',
    PURCHASE: 'purchase',
};
